import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "core-js";

import "./i18n";
import { BrowserRouter as Router } from "react-router-dom";

const root = createRoot(document.getElementById("root")!);
root.render(
  <Router>
    <App />
  </Router>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
